module.exports = __webpack_public_path__ + "img/frame (107).fb1d7950.jpg";